module.exports = __webpack_public_path__ + "img/HINDU DIWALI BW.15ad526.svg";